import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { CoreNavigationTabsComponent } from './core-navigation-tabs/core-navigation-tabs.component';
import { ComponentsModule } from '@fi-app/components/components.module';
import { CoreService } from './core.service';
import { UIRouterModule } from '@uirouter/angular';
import { FiCoreStates } from '@fi-app/core/core-states';
import { MediaBankStates } from '@fi-app/media-bank/media-bank-states';
import { FiUserStates } from '@fi-app/user/user-states';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        ComponentsModule,
        UIRouterModule.forChild(FiCoreStates),
        UIRouterModule.forChild(FiUserStates),
        UIRouterModule.forChild(MediaBankStates),
        MatButtonModule,
        MatIconModule,
        FiItemsListModule,
    ],
    declarations: [CoreNavigationTabsComponent],
    providers: [CoreService],
})
export class CoreModule {}
